import React, {useState} from "react";
import {Card, Col, Row} from "antd";
import NewsDashboardList from "../components/puDashboard/NewsDashboardList";
import NewsDashboardKeywordCloud from "../components/puDashboard/NewsDashboardKeywordCloud";
import {Column} from "@ant-design/plots";
import {VscsApi} from "../services/VscsApi";
import {useMount} from "ahooks";

const PuDashboardPage = () => {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([]);
    const requestData = () => {
        setLoading(true)
        VscsApi.flow()
            .onSuccess(_data => {
                const d = _data.map(d => {
                    return {
                        ...d,
                        value: Number(d.value)
                    }
                })
                setData([...d])
            })
            .onComplete(() => {
                setLoading(false)
            })
    }

    useMount(() => {
        requestData()
    })


    const config = {
        data,
        isStack: true,
        xField: 'venue',
        yField: 'value',
        seriesField: 'type',
        label: {
            // 可手动配置 label 数据标签位置
            position: 'middle',
            // 'top', 'bottom', 'middle'
            // 可配置附加的布局方法
            layout: [
                // 柱形图数据标签位置自动调整
                {
                    type: 'interval-adjust-position',
                }, // 数据标签防遮挡
                {
                    type: 'interval-hide-overlap',
                }, // 数据标签文颜色自动调整
                {
                    type: 'adjust-color',
                },
            ],
        },
    };

    return (
        <>
            <Row>
                {/*<Col xl={8} md={12} xs={24}>*/}
                {/*    <div style={{padding: 8}}>*/}
                {/*        <Card size="small" title="我的任务">*/}
                {/*            <List*/}
                {/*                itemLayout="horizontal"*/}
                {/*                dataSource={data}*/}
                {/*                renderItem={item => (*/}
                {/*                    <List.Item>*/}
                {/*                        <List.Item.Meta*/}
                {/*                            avatar={<Avatar src="https://joeschmoe.io/api/v1/random" />}*/}
                {/*                            title={<a href="https://ant.design">{item.title}</a>}*/}
                {/*                            description="Ant Design, a design language for background applications, is refined by Ant UED Team"*/}
                {/*                        />*/}
                {/*                    </List.Item>*/}
                {/*                )}*/}
                {/*            />*/}
                {/*        </Card>*/}
                {/*    </div>*/}
                {/*</Col>*/}
                {/*<Col xl={8} md={12} xs={24}>*/}
                {/*    <div style={{padding: 8}}>*/}
                {/*        <Card size="small" title="通知公告">*/}
                {/*        </Card>*/}
                {/*    </div>*/}
                {/*</Col>*/}
                {/*<Col xl={8} md={12} xs={24}>*/}
                {/*    <div style={{padding: 8}}>*/}
                {/*        <Card size="small" title="我的消息">*/}
                {/*        </Card>*/}
                {/*    </div>*/}
                {/*</Col>*/}

                <Col span={24}>
                    <Card title="今日场所流量" loading={loading}>
                        <Column {...config} />
                    </Card>
                </Col>

                <Col md={12} xs={24}>
                    <div style={{padding: 8}}>
                        <Card size="small" title="近期资讯">
                            <NewsDashboardList/>
                        </Card>
                    </div>
                </Col>
                <Col md={12} xs={24}>
                    <div style={{padding: 8}}>
                        <Card size="small" title="近期词条">
                            <NewsDashboardKeywordCloud/>
                        </Card>
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default PuDashboardPage